/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { translate } from '../fn/translate-content/translate';
import { Translate$Params } from '../fn/translate-content/translate';
import { TranslateResponse } from '../models/translate-response';

@Injectable({ providedIn: 'root' })
export class TranslateContentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `translate()` */
  static readonly TranslatePath = '/rest/translate';

  /**
   * Translate provided text with Google Translator.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `translate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  translate$Response(params: Translate$Params, context?: HttpContext): Observable<StrictHttpResponse<TranslateResponse>> {
    return translate(this.http, this.rootUrl, params, context);
  }

  /**
   * Translate provided text with Google Translator.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `translate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  translate(params: Translate$Params, context?: HttpContext): Observable<TranslateResponse> {
    return this.translate$Response(params, context).pipe(
      map((r: StrictHttpResponse<TranslateResponse>): TranslateResponse => r.body)
    );
  }

}
